import { connect } from 'react-redux'

import {
  setNumPagesTotal,
} from 'reduxpath/ducks/Product/Portfolio'

import FullTextPreview from 'components/FilePreview/FullTextPreview'

const mapStateToProps = state => ({
  numPages: state.ProductPortfolio.textNumPages,
})

const mapDispatchToProps = dispatch => ({

  setNumPages(pages) {
    dispatch(setNumPagesTotal(pages))
  },

})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FullTextPreview)
